<div class="row">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    #mainGrid
                    appAutoSize
                    [minHeight]="200"
                    (initialized)="grid.initialize(mainGrid); onGridInitialized()"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Report #'" [binding]="'reportNumber'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Source'" [binding]="'reportSource'" [width]="110"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Lab'" [binding]="'labName'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Sample Date'" [binding]="'sampleDate'" [width]="110"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Pour Location'" [binding]="'pourLocation'" [width]="180"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Mix No'" [binding]="'mixNo'" [width]="100"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Supplier'" [binding]="'supplier'" [dataMap]="supplierMap" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Specified PSI'" [binding]="'specifiedPsi'" [width]="110"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Inspector'" [binding]="'inspector'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Specimens'" [binding]="'numberOfSpecimens'" [width]="90"></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
